import * as React from "react";
import { SVGProps } from "react";

const BidirectionalArrow: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 8.42216C17 8.29892 16.9546 8.17568 16.8573 8.07838L12.92 4.14108C12.7319 3.95297 12.4205 3.95297 12.2324 4.14108C12.0443 4.32919 12.0443 4.64054 12.2324 4.82865L15.8259 8.42216L12.2324 12.0157C12.0443 12.2038 12.0443 12.5151 12.2324 12.7032C12.4205 12.8914 12.7319 12.8914 12.92 12.7032L16.8573 8.76595C16.9546 8.66865 17 8.54541 17 8.42216Z"
      fill={props?.fill || "#C6C6C6"}
    />
    <path
      d="M16.8897 8.42216C16.8897 8.15622 16.6692 7.93568 16.4032 7.93568L5.48649 7.93568C5.22054 7.93568 5 8.15622 5 8.42216C5 8.68811 5.22054 8.90865 5.48649 8.90865L16.4032 8.90865C16.6692 8.90865 16.8897 8.68811 16.8897 8.42216Z"
      fill={props?.fill || "#C6C6C6"}
    />
    <path
      d="M2 8.42216C2 8.29892 2.0454 8.17568 2.1427 8.07838L6.08 4.14108C6.26811 3.95297 6.57946 3.95297 6.76757 4.14108C6.95568 4.32919 6.95568 4.64054 6.76757 4.82865L3.17405 8.42216L6.76757 12.0157C6.95568 12.2038 6.95568 12.5151 6.76757 12.7032C6.57946 12.8914 6.26811 12.8914 6.08 12.7032L2.1427 8.76595C2.0454 8.66865 2 8.54541 2 8.42216Z"
      fill={props?.fill || "#C6C6C6"}
    />
    <path
      d="M2.11027 8.42216C2.11027 8.15622 2.33081 7.93568 2.59676 7.93568L13.5135 7.93568C13.7795 7.93568 14 8.15622 14 8.42216C14 8.68811 13.7795 8.90865 13.5135 8.90865L2.59676 8.90865C2.33081 8.90865 2.11027 8.68811 2.11027 8.42216Z"
      fill={props?.fill || "#C6C6C6"}
    />
  </svg>
);

export default BidirectionalArrow;
